export default __webpack_public_path__ + "media/flags/st-18d2a5b9.svg";